// import config from 'config';
import axios from 'axios';
import { handleResponse } from './http-utils';

export const refCadenceService = {
    getByAccount,
    getById,
    add,
    update,
    deleteEntity
};

function getByAccount(accountId) {
    // return axios.get(`/areas/?accountId=${accountId}`).then(handleResponse);
    return axios.get(`/refCadences/`).then(handleResponse);
}

function getById(id) {
    return axios.get(`/refCadences/${id}`).then(handleResponse);
}

function add(refCadence) {
    return axios.post('/refCadences', refCadence).then(handleResponse);
}

function update(refCadence) {
    return axios.put(`/refCadences/${refCadence.refCadenceId}`, refCadence).then(handleResponse);
}

function deleteEntity(refCadence) {
    return axios.delete(`/refCadences/${refCadence.refCadenceId}`).then(handleResponse);
}
